// extracted by css-extract-rspack-plugin
export default {"LazyRelationshipsSecurityAlertsListView_LoadMore":"LazyRelationshipsSecurityAlertsListView-module__LazyRelationshipsSecurityAlertsListView_LoadMore__eyh1X"};